import React, { useState, useEffect } from 'react';
import {
    Grid,
    Stack,
    Avatar,
    IconButton,
    Typography,
    Button,
    Paper,
    Card,
    Box,
    CardContent,
    Popper,
    CardMedia,
    Tooltip
} from '@mui/material';
import { ExpandMore, Adb, ExpandLess, ChevronLeft, ChevronRight } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import Carousel from 'react-multi-carousel';
import SubCardCollapase from 'ui-component/cards/SubCardCollapase';
import moment from 'moment';
import 'moment/locale/es';
import 'react-multi-carousel/lib/styles.css';
import { width } from '@mui/system';

const useStyle = makeStyles((theme) => ({
    principal: {
        position: 'relative',
        width: '100%'
    },
    boton: {
        position: 'fixed',
        right: '30px',
        bottom: '10px'
    },
    root: {
        minWidth: '100%',
        backgroundColor: '#E0E0E0',
        marginRight: '20px',
        '&:hover': {
            cursor: 'pointer'
        }
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)'
    },
    title: {
        fontSize: 14
    },
    pos: {
        marginBottom: 12
    },
    btnCancelar: {
        color: theme.palette.btn.red,
        '&:hover': {
            backgroundColor: theme.palette.btn.red,
            color: theme.palette.btn.white
        }
    }
}));

const borderColors = {
    red: '#E53935',
    yellow: '#FDD835',
    green: '#43A047',
    cm: '#b6a268'
};

const Tarjeta = (props) => {
    const { curso, selectCurso, borderColor = 'cm' } = props;

    const getTitulo = (item) => {
        if (item.idCurso) {
            if (item.tipoGrupo === 2) {
                const hoy = moment();
                const fechaInicio = moment(item.fechaInicio);
                const fechaFin = moment(item.fechaFin);
                if (hoy >= fechaInicio && hoy <= fechaFin) {
                    return item.isAprobado === 1 ? 'Curso completado' : 'Curso disponible';
                }
                return 'Curso finalizado';
            }
            return item.isAprobado === 1 ? 'Curso completado' : 'Curso disponible';
        }
        return 'Anuncio';
    };

    const getTexto = (item) => (item.idCurso ? item.titulo : item.anuncio);

    return (
        <Tooltip title={getTexto(curso)} placement="top">
            <Box sx={{ padding: '10px', height: '100%' }}>
                <Card
                    variant="outlined"
                    onClick={() => selectCurso(curso)}
                    sx={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        border: `1px solid ${borderColors[borderColor]}`,
                        borderRadius: '16px',
                        cursor: 'pointer',
                        transition: 'border-color 0.25s ease, box-shadow 0.2s ease',
                        '&:hover': {
                            boxShadow: `0 0 0 1px ${borderColors[borderColor]}40`
                        }
                    }}
                >
                    <CardMedia
                        component="img"
                        image={curso?.portadaCursoMostrar ?? 'https://cdn.pixabay.com/photo/2012/12/14/04/41/e-mail-69911_960_720.jpg'}
                        alt="portada"
                        sx={{
                            width: '100%',
                            // Altura responsiva: más pequeña en móvil, más grande en desktop
                            height: { xs: 120, sm: 150, md: 160 },
                            objectFit: 'cover',
                            // Respeta el border-radius del card arriba
                            borderRadius: '13px 13px 0 0',
                            flexShrink: 0
                            // padding: '5px'
                        }}
                    />

                    <CardContent
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            // Padding responsivo
                            p: { xs: 1.5, sm: 2 },
                            '&:last-child': { pb: { xs: 1.5, sm: 2 } }
                        }}
                    >
                        <Box>
                            <Typography variant="caption" color="text.secondary" gutterBottom sx={{ display: 'block', fontWeight: 500 }}>
                                {getTitulo(curso)}
                            </Typography>
                            <Typography
                                variant="h6"
                                component="h2"
                                sx={{
                                    fontSize: { xs: '0.95rem', sm: '1.1rem' },
                                    lineHeight: 1.3,
                                    // Truncar a 2 líneas si el texto es muy largo
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden'
                                }}
                            >
                                {getTexto(curso)}
                            </Typography>
                        </Box>

                        {curso.Descripcion && (
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                    mt: 1,
                                    display: '-webkit-box',
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: 'vertical',
                                    overflow: 'hidden'
                                }}
                            >
                                {curso.Descripcion}
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            </Box>
        </Tooltip>
    );
};

const ItemCarousel = (props) => {
    const { cursos, selectCurso } = props;
    const classes = useStyle();

    const [listaCursos, setListaCursos] = useState([]);

    useEffect(() => {
        if (cursos && cursos.length > 0) {
            let nuevaLista = [];
            cursos.forEach((el) => {
                if (el.idCurso) {
                    nuevaLista.push(el);
                } else {
                    const hoy = moment();
                    let inicio = null;
                    if (el.periodo && el.periodo == 'ANUAL') {
                        let actual = new Date();
                        let year = actual.getFullYear();
                        let arr = el.inicio.split('-');

                        inicio = moment(year, arr[1], arr[2]);
                    } else {
                        inicio = moment(el.inicio);
                    }

                    if (el.fin != 'NO') {
                        const fin = moment(el.fin);
                        if (hoy >= inicio && hoy <= fin) {
                            nuevaLista.push(el);
                        }
                    } else {
                        if (inicio <= hoy) {
                            nuevaLista.push(el);
                        }
                    }
                }
            });

            setListaCursos([...nuevaLista]);
        }
    }, [cursos]);
    return (
        <>
            <Typography variant="title" sx={{ color: '#b6a268', padding: '5px' }}>
                CURSOS DISPONIBLES
            </Typography>
            <div style={{ width: '100%', padding: '20px' }}>
                <Carousel
                    additionalTransfrom={0}
                    arrows
                    autoPlay
                    autoPlaySpeed={6000}
                    centerMode={false}
                    className={classes.carrusel}
                    dotListClass=""
                    draggable
                    focusOnSelect={false}
                    infinite
                    keyBoardControl
                    minimumTouchDrag={80}
                    pauseOnHover
                    renderArrowsWhenDisabled={false}
                    renderButtonGroupOutside={false}
                    renderDotsOutside={false}
                    responsive={{
                        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
                        tablet: { breakpoint: { max: 1024, min: 640 }, items: 3 },
                        mobile: { breakpoint: { max: 640, min: 0 }, items: 1 }
                    }}
                    rewind={false}
                    rewindWithAnimation={false}
                    rtl={false}
                    shouldResetAutoplay
                    // showDots
                    sliderClass=""
                    slidesToSlide={1}
                    swipeable
                    itemClass="px-2" // espacio entre cards (con Tailwind)
                    containerClass="py-4"
                >
                    {listaCursos?.map((curso, index) => (
                        <Tarjeta key={`cur${index}`} curso={curso} selectCurso={selectCurso} />
                    ))}
                </Carousel>
            </div>
        </>
    );
};

export default ItemCarousel;
